import React from "react"
import { WingsModal } from "@wingspans-ui"
import { FormattedMessage } from "react-intl"

const ResumeTipsModal = ({ show, onClose }) => {
  return (
    <WingsModal
      className="resume-tips-modal"
      isOpen={show}
      onClose={() => onClose()}
      size="lg"
      title={<FormattedMessage id="portfolio-tips-modal-tips" defaultMessage="Tips" />}
      titleLevel={5}
      backActionLabel={<FormattedMessage id="portfolio-tips-modal-back" defaultMessage="Back"/>}
      onBackAction={onClose}
    >
      <WingsModal.Body>
        <ul>
          <li><FormattedMessage
            id="portfolio-tips-modal-list-1"
            defaultMessage="Tailor your resume for every job application."
          /></li>
          <li><FormattedMessage
            id="portfolio-tips-modal-list-2"
            defaultMessage={`Use action words! For example, "Managed a crew of 8 technicians,"
                not "Was in charge of a crew of 8 technicians."`}
          />
          </li>
          <li><FormattedMessage
            id="portfolio-tips-modal-list-3"
            defaultMessage={`Be as specific as possible. For example, "Managed a team of 8
                technicians in completing X projects, resulting in a Y% increase in
                productivity."`}
          />
          </li>
          <li><FormattedMessage
            id="portfolio-tips-modal-list-4"
            defaultMessage={`Add keywords to your resume from the job posting.`}
          /></li>
          <li><FormattedMessage
            id="portfolio-tips-modal-list-5"
            defaultMessage={`Craft compelling bullet points using the highlights fields.`}
          /></li>
          <li><FormattedMessage
            id="portfolio-tips-modal-list-6"
            defaultMessage={`Don't focus on tasks, instead explain what those tasks achieved.`}
          />
          </li>
        </ul>
      </WingsModal.Body>
    </WingsModal>
  )
}

export default ResumeTipsModal
